"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function TableExpandIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 0v24H0V0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 13.586L7.707 9.293a1 1 0 1 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 1 0-1.414-1.414L12 13.586z"
  })));
}

var _default = TableExpandIcon;
exports.default = _default;
